/*global window*/

/**
 * HandleAdsMessage
 *
 * @class HandleAdsMessage
 * @param {event} message sent to current window
 */

const recalculatePropertyFeatureHeight = function() {
  const fluidPropertyFeatureHeight = 150;
  let propertyFeatures = $('.load-more-features');
  let expandedHeight = propertyFeatures.data('expandedHeight');
  let newHeight = expandedHeight+fluidPropertyFeatureHeight;
  $('#div-gpt-ad-HOMSVC1, #div-gpt-ad-HOMSVC2, #div-gpt-ad-HOMSVC3').addClass('fluid-property_feature');
  $('#div-gpt-ad-HOMSVC1, #div-gpt-ad-HOMSVC2, #div-gpt-ad-HOMSVC3').css({'height': fluidPropertyFeatureHeight});

  propertyFeatures.data('expandedHeight', newHeight);
  propertyFeatures.css({'height': newHeight});
};

const swipePhoto = function(photos, left, right){
  if (photos.length === 0) {
    return;
  }
  if (left) {
    photos.trigger('next.owl.carousel');
  }
  else if (right) {
    photos.trigger('prev.owl.carousel');
  }
};

const homepageRibbon = function(jsonMsg) {
  if (jsonMsg.ad_type === 'vu')
  {
    $('.vu-disclaimer-border').removeClass('hide');
  }
};

const DapCTA = function(jsonMsg) {
  let phoneNumber = jsonMsg.phoneNumber.replace(/\(|\)| |-/g, '');
  window.location.href= 'tel://' + phoneNumber;
};

const processJsonMessage = function (jsonMsg) {
  switch (jsonMsg.type) {
    case 'DAP_CTA':
      DapCTA(jsonMsg);
      break;
    case 'HOMSVC_AD':
      $('.header-subsection-home-service').removeClass(jsonMsg.ad_unit_empty);
      break;
    case 'HOMEPAGERIBBON':
      homepageRibbon(jsonMsg);
      break;
  }
};

const handleJsonMessage = function(msg) {
  try
  {
    let jsonMsg = JSON.parse(msg);
    processJsonMessage(jsonMsg);
  }
  catch(e) { /* ignore */ }
};

const handleMdnAdsMessage = function(event) {
  switch(event.data) {
    case 'VU_OVERLAY':
      window._satellite.track('ldp:ads:overlay:veterans');
      break;
    case 'VU_GUIDEPOST':
      window._satellite.track('ldp:ads:guidePost:veterans');
      break;
  }
  if (event.data === 'VU_POPS_UP') {
    var expiration = MOVE.Helper.setCookieExpiry(60*24*6);
    $.cookie('VU_POPS_UP', 1, {expires: expiration, path: '/'});
  }
};

const handleGooglesyndicationAdsMessage = function(event) {
  switch(event.data) {
    case 'SWPIE_LEFT':
      swipePhoto($('#cmtPhotoGallery'), true, false);
      break;
    case 'SWPIE_RIGHT':
      swipePhoto($('#cmtPhotoGallery'), false, true);
      break;
  }
  if (event.data === 'TXTIN2_DAP') {
    $('#div-gpt-ad-TXTIN2').find('.txtinadslistview').addClass('dap-size');
    $('#div-gpt-ad-TILELIST2').addClass('dap-mrect');
  }
  
  if(isJson(event.data) && JSON.parse(event.data).type === 'HOMSVC_AD'){
    recalculatePropertyFeatureHeight();
  }
  handleJsonMessage(event.data);
};

const isJson = function (str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}
//this function listen to message fired from ads inside iframe
const handleAdsMessage = function(event) {
  let origin = event.origin || event.originalEvent.origin;
  //s0.2mdn.net is CDN of gpt ads static files
  if (origin === "http://s0.2mdn.net" || origin === "https://s0.2mdn.net") {
    handleMdnAdsMessage(event);
  }
  //tpc.googlesyndication.com is another CDN of gpt ads static files
  if (origin === 'http://tpc.googlesyndication.com' || origin === 'https://tpc.googlesyndication.com') {
    handleGooglesyndicationAdsMessage(event);
  }
};

export const HandleAdsMessage = handleAdsMessage;



// WEBPACK FOOTER //
// ./shared_critical/media/message.js